/*
Monotype Foundry Platform API
Version 1.0.0

Definition: CreatePresignedUrlRequestForSubmission

Properties:
  keys: array
*/

var CreatePresignedUrlRequestForSubmission = (function () {
  function validateCreatePresignedUrlRequestForSubmission (arg) {
    // Validate keys
    if (arg.keys && !(Array.isArray(arg.keys))) {
      throw new Error('CreatePresignedUrlRequestForSubmission.keys: Wrong type: Got \'' + (typeof arg.keys) + '\', but expected: \'array\'')
    }
  }
  function buildCreatePresignedUrlRequestForSubmission (arg) {
    var CreatePresignedUrlRequestForSubmission = arg
    // Complete keys
    // Expected Type: array
    CreatePresignedUrlRequestForSubmission.keys = CreatePresignedUrlRequestForSubmission.keys || []
    return CreatePresignedUrlRequestForSubmission
  }
  return {
    validate: validateCreatePresignedUrlRequestForSubmission,
    build: buildCreatePresignedUrlRequestForSubmission
  }
})()

module.exports = CreatePresignedUrlRequestForSubmission
